import { Module } from "vuex";
import { IRootState } from "@/store";
import {
  state,
  IEntityApprovalState,
} from "@/store/modules/entityApproval/state";
import { getters } from "@/store/modules/entityApproval/getters";
import { actions } from "@/store/modules/entityApproval/actions";
import { mutations } from "@/store/modules/entityApproval/mutations";

export const entityApproval: Module<IEntityApprovalState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
